// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pgVs0","newExpiryDate":"styles_newExpiryDate__Wc13m","footer":"styles_footer__1nnCv"};